export default __webpack_public_path__ + "static/media/analytics-payment-bg.55fb02f6.svg";